/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const TimerIcon = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 19" fill="none">
  <circle cx="7.5" cy="11.5" r="6.75" stroke="inherit" strokeWidth="1.5"/>
  <rect x="5" width="5" height="2" rx="1" fill="#282828"/>
  <path d="M6.44008 12.0791C6.11896 11.758 6.11896 11.2374 6.44007 10.9162L9.06137 8.29496C9.38248 7.97384 9.90312 7.97384 10.2242 8.29496C10.5453 8.61607 10.5453 9.1367 10.2242 9.45782L7.60294 12.0791C7.28182 12.4002 6.76119 12.4002 6.44008 12.0791Z" fill="#282828"/>
</svg>);

export default TimerIcon;